import Vue from 'vue'
import Router from 'vue-router'
// import Home from './Home'
// import Yinliu from './Yinliu'
// import Rscreen from './Rscreen'
// import Bt from './Bt'
// import Lanhu from './Lanhu'
// import Discode from './Discode'
// import Dbrt from './Dbrt'

import Validator from './Validator'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/validator'
      // redirect: '/discode/com.idostudy.mathematicss'
    },
    // {
    //   path: '/dbrt',
    //   name: 'Dbrt',
    //   component: Dbrt
    // },
    // {
    //   path: '/discode/:key',
    //   name: 'Discode',
    //   component: Discode
    // },
    // {
    //   path: '/bt',
    //   name: 'Bt',
    //   component: Bt
    // },
    {
      path: '/validator',
      name: 'Validator',
      component: Validator
    },
    // {
    //   path: '/lanhu',
    //   name: 'Lanhu',
    //   component: Lanhu
    // },
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: Home
    // },
    // {
    //   path: '/yinliu/:name',
    //   component: Yinliu
    // },
    // {
    //   path: '/rscreen',
    //   component: Rscreen
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js